import script from "./base-product.vue?vue&type=script&setup=true&lang=js"
export * from "./base-product.vue?vue&type=script&setup=true&lang=js"

import "./base-product.vue?vue&type=style&index=0&id=74f0852f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f0852f"]])

export default __exports__